<template>
  <div v-if="comeFunziona" class="come-funziona" ref="comefunziona">
    <common-hero :tag="'div'">
      <span class="common-hero__processing-order common-hero-label font-black">{{ comeFunziona.intro }}</span>
      <h1 v-if="comeFunziona.title" class="font-black" v-html="comeFunziona && comeFunziona.title !== '' ? comeFunziona.title.replace(/\n/g, '<br>') : ''" />
    </common-hero>
    <section v-if="comeFunziona.imageFlowDesk" class="padding-paragrafo padding-paragrafo--less-top" style="background-color: #EFEFEC">
      <div class="default-container">
        <picture>
            <source :srcset="comeFunziona.imageFlowDesk.url" media="(min-width: 1000px)">
            <img :src="comeFunziona.imageFlowMobile ? comeFunziona.imageFlowMobile.url : comeFunziona.imageFlowDesk.url" :alt="comeFunziona.intro">
          </picture>
      </div>
    </section>
    <section class="padding-paragrafo padding-paragrafo--less-bottom paragrafo-h-p hasUl font-black" style="background-color: #FFF">
      <div class="default-container">
        <h3 class="text-to-uppercase">{{ comeFunziona.introFasi }}</h3>
        <p v-if="comeFunziona.textFasi" class="font-black" v-html="comeFunziona && comeFunziona.textFasi !== '' ? comeFunziona.textFasi.replace(/\n/g, '<br>'): ''" />
      </div>
    </section>
    <listing-come-funziona v-if="allFasis && allFasis.length > 0"
      :list="allFasis"
      :lang="lang" />
    <section class="padding-paragrafo-bottom" style="background-color: #FFF; text-align: right">
      <div class="default-container">
        <div class="flex-right">
          <div
            class="scroll-top"
            @click="$_scrollTop">
            <img src="/come-funziona/arrow-top.svg" width="17px" height="17px" alt="arrow.top" />
            <p v-html="$t('tornaSopra')" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import lang from '@/views/mixins/lang'
import dataLoad from '@/views/mixins/dataLoad'
import ListingComeFunziona from '@/components/ListingComeFunziona'
import CommonHero from '@/components/CommonHero'
import { howToData } from '@/queries/come-funziona.js'

export default {
  mixins: [ lang, dataLoad ],
  components: {
    ListingComeFunziona,
    CommonHero
  },
  data: () => ({
    allFasis: [],
    comeFunziona: {},
    seo: {}
  }),
  apollo: {
    comeFunziona: {
      query: howToData,
      fetchPolicy: 'cache-and-network',
      prefetch: true,
      variables () {
        return {
          locale: this.$i18n.locale
        }
      },
      result (result) {
        if (result.data) {
          this.allFasis = result.data.allFasis
          this.comeFunziona = result.data.comeFunziona
          this.seo = result.data.comeFunziona.seo
        }
      }
    }
  },
  computed: {
    imgServer: {
      get () {
        return process.env.VUE_APP_ENDPOINT
      }
    }
  },
  methods: {
    $_scrollTop () {
      window.scroll({ top: this.$refs.comefunziona.offsetTop, left: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style lang="scss">

  @import "../assets/mixins/breakpoints";
  @import "../assets/mixins/typo";

  .come-funziona{

    .listing-come-funziona ul{
      padding-bottom: 90px;
      @media #{$medium_mq} {
        padding-bottom: 130px;
      }
      @media #{$large_mq} {
        padding-bottom: 160px;
      }
      @media #{$xlarge_mq} {
        padding-bottom: 190px;
      }
    }

    picture{
    width: 100%;
      img{
        width: 100%; height: auto;
        display: block;
      }
    }

    .listing-come-funziona__content{
      position: relative;
      padding: 4rem 0;
      border-top: 1px solid #4A4A4A;
      transform: translate3d(0, 0, 0);
      top: 0;
      display: block;
      z-index: 20;

      h3{
        font-size: 4.8rem;
        line-height: 1.2;
      }

      p{
        font-size: 1.6rem;
        line-height: 1.8;
      }

      .hero-cta{
        padding: 2rem 0;
      }

      @media #{$medium_mq} {
        .default-container{
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          min-height: 250px;
        }

        h3{
          font-size: 4.2rem;
          line-height: 1.2;

          width: 35%;
          align-self: center;
          margin: 1rem 0 2rem;
        }
        p{
          font-size: 1.2rem;
          line-height: 1.6;

          width: 53%;
          padding-right: 10%;
          padding-left: 10%;
          align-self: center;
        }
        .hero-cta{
          width: 12%;
          text-align: right;
          align-self: center;
          img{
            margin-right: 0;
          }
        }

      }

      @media #{$large_mq} {
        h3{
          font-size: 4.6rem;
          line-height: 1.2;
        }
        p{
          font-size: 1.5rem;
          line-height: 1.6;
        }
      }

      @media #{$xlarge_mq} {
        h3{
          font-size: 7.7rem;
          width: 35%;
        }
        p{
          font-size: 1.8rem;
          width: 53%;
        }
      }

    }

    .listing-come-funziona__content--desktop{
      display: none;
    }
  }

  .flex-right{
    display: flex;
    justify-content: flex-end;
  }

  .scroll-top{
    width: 52px;
    text-align: center;
    cursor: pointer;
    p {
      font-size: .875rem;
      margin: 20px 0 0 0;
      font-family: 'IBM Plex Mono', sans-serif;
      font-weight: 400;
      text-transform: uppercase;
      letter-spacing: .05rem;
    }
    img{
      margin: 0;
    }
  }

</style>
